<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>
        <BlockUI v-if="agent.busy">
            <div class="loader"></div>
        </BlockUI>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-12 col-md-12 col-xl-8 mb-3">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">แก้ไขตัวแทนจำหน่าย</h3>
                                </div>
                            </div>
                        </div>
                        <FormAgent
                            :agent="agent"
                        />
                    </card>
                </div>
                <div class="col-12 col-md-12 col-xl-4">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <CardVerifyStatus ref="cardStatus" />
                        </div>
                        <div class="col-12 mb-3">
                            <CardAgentCourier ref="cardCourier"/>
                        </div>
                        <div class="col-12 mb-3" v-if="this.$USER_LOGIN.get().isShippop">
                            <CardAllowCourier 
                                :agent="agent"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import FormAgent from '@/components/custom/agent/FormAgent'
import CardVerifyStatus from '../components/custom/agent/CardVerifyStatus.vue'
import CardAgentCourier from '../components/custom/agent/CardAgentCourier.vue'
import CardAllowCourier from '../components/custom/agent/CardAllowCourier.vue'
import { getOneAgent, getReceiptInfoAgent } from "@/axios/agent.js";
import { showErrorModal } from "@/components/modalNotification.js";

export default {
    name:'agent',
    components:{
        FormAgent,
        CardVerifyStatus,
        CardAgentCourier,
        CardAllowCourier
    },
    data(){
        return{
            agent:{
                busy: true,
                name: "",
                email: "",
                password: "",
                tax_id:"",
                address:"",
                state:"",
                district:"",
                province:"",
                postcode:"",
                tel:"",
                receiptEmail:"",
                receiptName:"",
                companyName:"",
                receiptType:"person",
                pgwPublicKey: "",
                pgwPrivateKey: "",
                signatureName: "",
                forceUseWallet: false,
                logo:{
                    preview:null,
                    file:null
                },
                signature:{
                    preview:null,
                    file:null
                },
                sale:{
                    saleName:"",
                    saleTel:"",
                    saleIdLine:"",
                    saleId: null,
                    listSale:[],
                },
                vat: 0,
                walletOpen: null,
                selectedCourier: [],
                paymentType:(this.$THEME.name == 'shippop') ? 'CREDIT_SHIPPOP' : 'PREPAID',
                paymentCondition: (this.$THEME.name == 'shippop') ? '' : null,
            }
        }
    },
    async mounted(){
        await getOneAgent( this.$route.params.Id ).then( (res) => {
            this.agent.name = res.agent.name
            this.agent.email = res.agent.email
            this.agent.walletOpen = res.agent.wallet_open
            this.agent.forceUseWallet = res.agent.wallet_open
            this.agent.pgwPublicKey = (this.agent.walletOpen) ? res.agent.pgw_public_key : '';
            this.agent.pgwPrivateKey = (this.agent.walletOpen) ? res.agent.pgw_private_key : '';
            if( res.agent.payment_type ){
                this.agent.paymentType = res.agent.payment_type;
                this.agent.paymentCondition = res.agent.payment_condition?parseInt(res.agent.payment_condition):res.agent.payment_condition;
            }
            this.agent.sale.listSale = ( res.agent.list_sale_support ) ? res.agent.list_sale_support : [];
            if( res.agent.sale ){
                this.agent.sale.saleName = res.agent.sale.name
                this.agent.sale.saleTel = res.agent.sale.tel
                this.agent.sale.saleIdLine = res.agent.sale.line_id
                this.agent.sale.saleId = res.agent.sale.id
            }
            this.$refs.cardStatus.commission.statusVerify = res.status_commission.status_resgister
            this.$refs.cardStatus.commission.remarkVerify = res.status_commission.status_remark
            this.$refs.cardCourier.agentCourier = res.agent.default_courier;
        }).catch(error => {
            console.log( error )
            showErrorModal( error )
        })

        await getReceiptInfoAgent( this.$route.params.Id ).then( (res) => {
            if( res ){
                this.agent.receiptName = res.name
                this.agent.receiptEmail = res.email
                this.agent.companyName = res.company_name
                this.agent.tax_id = res.tax_id
                this.agent.address = res.address
                this.agent.state = res.state
                this.agent.district = res.district
                this.agent.province = res.province
                this.agent.postcode = res.postcode
                this.agent.tel = res.tel
                this.agent.logo.preview = res.logo
                this.agent.signature.preview = res.signature_url
                this.agent.signatureName = res.signature_name
            }
        }).catch(error => {
            showErrorModal( error )
        })

        this.agent.busy = false
    }
}
</script>